import { PopoverComboboxOption } from '@/components/ui/custom/PopoverCombobox';
import useCollections from '@/hooks/useCollections';

export const useCollectionOptions = () => {
  const { collections, isCollectionsLoading } = useCollections();
  const options: PopoverComboboxOption[] = (collections ?? []).map(({ collection_id, name }) => ({
    value: collection_id,
    label: name,
  }));
  return { options, isLoading: isCollectionsLoading };
};
